import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/svg/free-proxy-list.svg'


const _withScopeId = n => (_pushScopeId("data-v-6c0d8d98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_2 = { class: "itemcard downloadcard" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Socks4 Proxies", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Last updated: ")
const _hoisted_8 = { id: "socks4lastupdated" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { id: "socks4proxyamount" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" proxies ")
const _hoisted_12 = { class: "selectors" }
const _hoisted_13 = { for: "socks4timeoutslide" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Timeout: ")
const _hoisted_15 = { id: "socks4timeoutoutput" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("ms")
const _hoisted_17 = {
  class: "nice-select selectortypes",
  tabindex: "0"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Country: "),
  /*#__PURE__*/_createElementVNode("span", { class: "current" }, "all")
], -1))
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<li data-value=\"all\" class=\"option\" data-v-6c0d8d98>all</li><li data-value=\"BR\" class=\"option\" data-v-6c0d8d98>BR</li><li data-value=\"IN\" class=\"option\" data-v-6c0d8d98>IN</li><li data-value=\"US\" class=\"option\" data-v-6c0d8d98>US</li><li data-value=\"RU\" class=\"option\" data-v-6c0d8d98>RU</li><li data-value=\"KR\" class=\"option\" data-v-6c0d8d98>KR</li><li data-value=\"NP\" class=\"option\" data-v-6c0d8d98>NP</li><li data-value=\"AR\" class=\"option\" data-v-6c0d8d98>AR</li><li data-value=\"GB\" class=\"option\" data-v-6c0d8d98>GB</li><li data-value=\"VN\" class=\"option\" data-v-6c0d8d98>VN</li><li data-value=\"BD\" class=\"option\" data-v-6c0d8d98>BD</li><li data-value=\"TH\" class=\"option\" data-v-6c0d8d98>TH</li><li data-value=\"UA\" class=\"option\" data-v-6c0d8d98>UA</li><li data-value=\"IR\" class=\"option\" data-v-6c0d8d98>IR</li><li data-value=\"PL\" class=\"option\" data-v-6c0d8d98>PL</li><li data-value=\"CZ\" class=\"option\" data-v-6c0d8d98>CZ</li><li data-value=\"ID\" class=\"option\" data-v-6c0d8d98>ID</li><li data-value=\"CO\" class=\"option\" data-v-6c0d8d98>CO</li><li data-value=\"RO\" class=\"option\" data-v-6c0d8d98>RO</li><li data-value=\"CR\" class=\"option\" data-v-6c0d8d98>CR</li><li data-value=\"PH\" class=\"option\" data-v-6c0d8d98>PH</li><li data-value=\"BG\" class=\"option\" data-v-6c0d8d98>BG</li><li data-value=\"FR\" class=\"option\" data-v-6c0d8d98>FR</li><li data-value=\"ES\" class=\"option\" data-v-6c0d8d98>ES</li><li data-value=\"CN\" class=\"option\" data-v-6c0d8d98>CN</li><li data-value=\"TR\" class=\"option\" data-v-6c0d8d98>TR</li><li data-value=\"HN\" class=\"option\" data-v-6c0d8d98>HN</li><li data-value=\"RS\" class=\"option\" data-v-6c0d8d98>RS</li><li data-value=\"MN\" class=\"option\" data-v-6c0d8d98>MN</li><li data-value=\"IQ\" class=\"option\" data-v-6c0d8d98>IQ</li><li data-value=\"IT\" class=\"option\" data-v-6c0d8d98>IT</li><li data-value=\"DE\" class=\"option\" data-v-6c0d8d98>DE</li><li data-value=\"NG\" class=\"option\" data-v-6c0d8d98>NG</li><li data-value=\"ZA\" class=\"option\" data-v-6c0d8d98>ZA</li><li data-value=\"KH\" class=\"option\" data-v-6c0d8d98>KH</li><li data-value=\"MX\" class=\"option\" data-v-6c0d8d98>MX</li><li data-value=\"LB\" class=\"option\" data-v-6c0d8d98>LB</li>", 37)
const _hoisted_56 = [
  _hoisted_19
]
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<div class=\"nice-select selectortypes\" tabindex=\"0\" data-v-6c0d8d98><span data-v-6c0d8d98>Anonymity: <span class=\"current\" data-v-6c0d8d98>only for http proxies</span></span><ul class=\"list\" data-v-6c0d8d98><li data-value=\"only for http proxies\" class=\"option selected\" data-v-6c0d8d98> only for http proxies </li></ul></div><select class=\"nice-select\" name=\"option\" style=\"display:none;\" data-v-6c0d8d98><option value=\"\" data-v-6c0d8d98>only for http proxies</option></select><div class=\"nice-select selectortypes\" tabindex=\"0\" data-v-6c0d8d98><span data-v-6c0d8d98>SSL: <span class=\"current\" data-v-6c0d8d98>only for http proxies</span></span><ul class=\"list\" data-v-6c0d8d98><li data-value=\"only for http proxies\" class=\"option selected\" data-v-6c0d8d98> only for http proxies </li></ul></div>", 3)
const _hoisted_60 = { class: "downloadbtn" }
const _hoisted_61 = ["href"]
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_63 = ["href"]

import { socks4State } from '@/composables/free-proxies';
import FreeProxies from '@/services/api/fproxy-service';
import nProgress from 'nprogress';
import { onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* eslint-disable @typescript-eslint/no-explicit-any */

const url = 'https://api.proxyscrape.com/v2/';
const proxyInfo = async () => {
  const proxyInf = await FreeProxies.proxyInfoSocks4();
  socks4State.proxy_info.proxy_count = proxyInf.data.proxy_count;
  socks4State.proxy_info.last_updated = proxyInf.data.last_updated;
};
proxyInfo();

const onTimeout = () => {
  proxyInfo();
};
const getCountry = (click: any) => {
  socks4State.country = click.target.outerText;
  proxyInfo();
};

const onDownload = () => {
  nProgress.start();
  setTimeout(() => {
    setTimeout(() => nProgress.done(), 400);
  }, 300);
};

onUnmounted(() => {
  socks4State.getproxies = 'getproxies';
  socks4State.type = 'socks4';
  socks4State.timeout = 10000;
  socks4State.country = 'all';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: `${url}?request=getproxies&protocol=socks4&timeout=${_unref(socks4State).timeout}&country=${_unref(socks4State).country}`,
        onClick: onDownload
      }, _hoisted_6, 8, _hoisted_3),
      _createElementVNode("p", null, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(socks4State).proxy_info.last_updated), 1),
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(socks4State).proxy_info.proxy_count), 1),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(socks4State).timeout), 1),
          _hoisted_16
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "range",
          step: "50",
          min: "50",
          max: "10000",
          class: "slider",
          id: "socks4timeoutslide",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(socks4State).timeout) = $event)),
          onChange: onTimeout
        }, null, 544), [
          [_vModelText, _unref(socks4State).timeout]
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("ul", {
            class: "list socks4country countryselect",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (getCountry($event)))
          }, _hoisted_56)
        ]),
        _hoisted_57
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("a", {
          href: `${url}?request=getproxies&protocol=socks4&timeout=${_unref(socks4State).timeout}&country=${_unref(socks4State).country}`,
          style: {"cursor":"pointer"},
          class: "save-btn",
          onClick: onDownload
        }, "Download", 8, _hoisted_61),
        _hoisted_62,
        _createElementVNode("a", {
          href: `${url}?request=share&protocol=socks4&timeout=${_unref(socks4State).timeout}&country=${_unref(socks4State).country}`,
          style: {"cursor":"pointer"}
        }, "Share", 8, _hoisted_63)
      ])
    ])
  ]))
}
}

})